import {
  ReactNode, useEffect,
} from 'react';
import router from 'next/router';
import { useApplicationState } from 'lib/contexts/ApplicationState';
import { goToLogin, goToSignup } from 'lib/redirect';

interface Props {
  children: ReactNode;
  userRequired?: boolean;
  fallback?: ReactNode;
  redirectMessage?: string;
}

export const AwaitUserAuth = ({
  children, userRequired, fallback, redirectMessage,
}: Props) => {
  const { isAuthed, currentUser } = useApplicationState();

  useEffect(() => {
    if (isAuthed && !currentUser?.id && userRequired) {
      if (!redirectMessage) {
        goToLogin(currentUser, router, router.asPath);
        goToSignup(currentUser, router);
      } else {
        const timer = setTimeout(() => {
          goToLogin(currentUser, router, router.asPath);
          goToSignup(currentUser, router);
        }, 3000);

        return () => clearTimeout(timer);
      }
    }
    return undefined;
  }, [isAuthed, currentUser?.id, userRequired]);

  if (!isAuthed || (!currentUser && userRequired)) {
    if (fallback) {
      return <>{fallback}</>;
    }

    if (isAuthed && redirectMessage && !currentUser) {
      return (
        <div className="flex items-center justify-center min-h-screen text-center p-8 text-2xl text-black dark:text-white">
          {redirectMessage}
        </div>
      );
    }

    return null;
  }

  return <>{children}</>;
};
